import { withBase } from 'ufo';
import seoConfig from '~~/configs/seo.config';

// Head links are root-relative in the config; prefix them with the app baseURL (e.g. /preview/)
// at runtime, because app.head does not do this itself.
export default defineNuxtPlugin(() => {
  const baseURL = useRuntimeConfig().app.baseURL || '/';

  useHead({
    link: seoConfig.link.map((link) => ({ ...link, href: withBase(link.href, baseURL) })),
  });
});
